<div class="editor-container d-flex flex-column h-100 justify-content-between">
  <div class="flex-fill bg-white ">
    <quill-editor class="h-100 d-block" [(ngModel)]="content" [modules]="quillConfig" spellcheck="true"></quill-editor>
  </div>

  <div class="d-flex justify-content-end gap-3 p-2">

    @if([appPermissions.editPolicy,permissionsActions.edit] | builderPermissions){
      <button mat-raised-button *ngIf="policyId" (click)="resetPolicyDialog()">Reset policy</button>
    }
    <span class="flex-fill"></span>
    <button mat-raised-button [matTooltip]="policyURL" *ngIf="policyURL" (click)=" copyToClipboard(policyURL);sendtoastr('coppied')">Policy url </button>
    @if([appPermissions.editPolicy,permissionsActions.edit] | builderPermissions){
      <button mat-raised-button color="primary" [disabled]="!content" (click)="saveContent()">{{ policyId ? 'Update policy':'Save Policy' }}</button>
    }
  </div>
</div>

 
<ng-template  #policyTemplate>
  <h2 mat-dialog-title>Application policy</h2>
<mat-dialog-content>
  <div  *ngIf="saved">
    <div class="genarated-link ps-5">
      <div class="link-text pt-2 ">
         <h6>Policy URL</h6>  
        <div class="copy-url ">
          <span ><a [href]="policyURL" target="_blank" class="ellipsis-input">{{policyURL}}</a></span>
          <button mat-icon-button (click)="copyToClipboard(policyURL)">
            <mat-icon>content_copy</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="dailog-footer-buttons">
  <button mat-button color="primary" (click)="dialog.closeAll()">OK</button>
</mat-dialog-actions>
</ng-template>

<ng-template  #resetPolicyTemplate let-dialogRef="dialogRef">
  <h2 mat-dialog-title>Reset policy</h2>
<mat-dialog-content>
    <div class="content">Are you sure you want to reset the policy? This action cannot be undone. </div>
</mat-dialog-content>

<mat-dialog-actions class="d-flex dailog-footer-buttons">
  <button mat-button color="primary" (click)="dialogRef.close(false)">Cancel</button>
  <span class="flex-fill"></span>
  <button mat-button color="primary" (click)="dialogRef.close(true)">Sure</button>
</mat-dialog-actions>
</ng-template>